import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getReferralsFiltersRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/referrals/filters");

  return response.data;
};
